import React, { Fragment, PureComponent } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Button, ButtonToolbar, Table } from "reactstrap";

import "./styles.css";
import axios from "axios";
import _ from "lodash";
import Util from '../../Common/util';
import API from '../../Common/api';
import StarIcon from '../../../images/star_icon.svg'


var printDetails = {};

class PrintPickingNPPHulDetail extends PureComponent {
  constructor(props) {

    var tempDate = new Date();
    var date =
      tempDate.getFullYear() +
      "-" +
      (tempDate.getMonth() + 1) +
      "-" +
      tempDate.getDate() +
      " " +
      tempDate.getHours() +
      ":" +
      tempDate.getMinutes() +
      ":" +
      tempDate.getSeconds();
    const currDate = date;
    super(props);

    this.prinData = this.prinData.bind(this);
    this.state = {

      showPrintData: [],
      date: currDate,
      page_break_check: false,
    };

    this.showPassword = this.showPassword.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  }

  componentWillMount() {
    var printDetail_data = localStorage.getItem("printData");
    printDetails = JSON.parse(printDetail_data);
  }

  componentDidMount() {
    var printDetail_data = localStorage.getItem("printData");
    var printDetails = JSON.parse(printDetail_data);
    var page_break_check = localStorage.getItem("page_break_check");
    // page_break_check_val = page_break_check
    this.setState({
      page_break_check: page_break_check
    })

    console.log("page_break_check", page_break_check, this.state.page_break_check)




    setTimeout(this.prinData, 1100);


  }

  prinData() {
    window.print();
  }



  render() {
    const { handleSubmit } = this.props;
    //   const { showPassword } = this.state;
    const pickType = localStorage.getItem("pickType");
    const typeText = localStorage.getItem('selected_option');
    const arrData = JSON.parse(localStorage.getItem("printData"));
    var type_val;
    console.log("pickType", pickType);



    const ptlText = " Loose Picking Sheet"
    const manualText = "CLD Picking Sheet"

    const arrayValue = [];


    // console.log("arrayValue = ", arrayValue);
    // console.log(arrayValue.sort());
    var userIndex = 0;
    var itemLen = 0;
    var zoneNameArr = []
    var cld_to_be_picked_count = 0
    var page_break_check_val = this.state.page_break_check

    return (
      <div style={{ borderLeftWidth: 0, width: "99%" }} className="print_table">
        <table className="no_border_table" style={{ borderWidth: 0, backgroundColor: '#fff', marginBottom: 0, width: '99%', margin: 'auto', marginTop: 30 }}
        >
          <thead className="table_background"
            style={{ background: "#fff" }}
          >
            <tr style={{ marginTop: 20, background: "#fff" }}>

              <th style={{ textAlign: 'center' }} colspan="12">CLD Picking Sheet</th>

            </tr>
          </thead>
        </table>

        <div>
          {Object.keys(printDetails).map((user) => (


            <div>


              {Object.keys(printDetails[user]).map((zoneName) => (

                <div style={{ width: "99%", margin: 'auto', paddingBottom: 0 }}>
                  <span style={{ display: 'none' }}>{userIndex = userIndex + 1}</span>
                  <span style={{ display: 'none' }}>{itemLen = Object.keys(zoneName).length}</span>
                  <span style={{ display: 'none' }}>{zoneNameArr = []}</span>
                  <div

                  >
                    {pickType == "manual" &&

                      <div id="picksheetAlignment">
                        <table id="picksheet_table" style={{ width: '100%', padding: 15, borderWidth: 0, marginTop: 20 }}
                          responsive

                        >
                          <thead
                            className="thead_align table_background"
                            style={{ background: "#fff" }}
                          >


                            <tr className="header_color" style={{ marginTop: 20, background: "#fff" }}>
                              <th colspan="3" style={{ marginTop: 20 }}>
                                <h5>
                                  {" "}
                                  <span style={{ fontWeight: "bold", color: '#fff' }}>
                                    {" "}
                                    Trip ID:{" "}
                                  </span>{" "}
                                  <span style={{ color: '#fff' }}> {printDetails[user][zoneName][0].ptlId} </span>{" "}
                                </h5>
                              </th>

                              <th colspan="2" style={{ marginTop: 20 }}>
                                <h5>
                                  {" "}
                                  <span style={{ fontWeight: "bold", color: '#fff' }}>
                                    {" "}
                                    Van:{" "}
                                  </span>{" "}
                                  <span style={{ color: '#fff' }}> {printDetails[user][zoneName][0].van} </span>{" "}
                                </h5>
                              </th>
                              <th colspan="2" style={{ marginTop: 20 }}>
                                <h5>
                                  {" "}
                                  <span style={{ fontWeight: "bold", color: '#fff' }}>
                                    {" "}
                                    Zone:{" "}
                                  </span>{" "}
                                  <span style={{ color: '#fff' }}>  {printDetails[user][zoneName][0].zoneName} </span>{" "}
                                </h5>
                              </th>
                              <th colspan="4" style={{ marginTop: 20 }}>
                                <h5>
                                  {" "}
                                  <span style={{ fontWeight: "bold", color: '#fff' }}>
                                    {" "}
                                    Assigned User:{" "}
                                  </span>{" "}
                                  <span style={{ color: '#fff' }}> {user} </span>{" "}
                                </h5>
                              </th>
                              <th colspan="3" style={{ marginTop: 20, textAlign: 'right' }}>
                                <h5>
                                  {" "}
                                  <span style={{ fontWeight: "bold", color: '#fff' }}>
                                    {" "}
                                    Trip Date:{" "}
                                  </span>{" "}
                                  <span style={{ color: '#fff' }}>{printDetails[user][zoneName][0].added_on}</span>{" "}
                                </h5>
                              </th>

                            </tr>



                            <tr className="border-thead border_head border_thead" style={{ marginTop: 20 }}>
                              <th style={{ marginTop: 20 }}>Sr No.</th>

                              {/*<th style={{ marginTop: 20, width: 110 }}>Bin Id </th>*/}

                              <th style={{ marginTop: 20 }}>SkU7 </th>
                              <th style={{ marginTop: 20 }}> Prod Name </th>



                              <th style={{ marginTop: 20 }}> UPC </th>

                              <th style={{ marginTop: 20 }}>MRP </th>
                              {/* <th style={{ marginTop: 20 }}>PKD</th>*/}

                              <th style={{ marginTop: 20 }}>Free Product </th>
                              <th style={{ marginTop: 20 }}>Free Loose </th>

                              <th style={{ marginTop: 20 }}>Free CLD </th>
                              <th style={{ marginTop: 20 }}>Loose to be picked </th>
                              <th style={{ marginTop: 20 }}>Picked loose </th>
                              <th style={{ marginTop: 20 }}>CLD to be picked </th>
                              <th style={{ marginTop: 20 }}>Picked CLD </th>
                            </tr>
                          </thead>
                          <tbody>

                            {printDetails[user][zoneName].filter(valueDetail => valueDetail.totalIcldQty > 0).map((insideItem, index) => {
                              {
                                (insideItem.freeProduct == false) && (insideItem.totalIcldQty == 0 || insideItem.totalIcldQty == "") ? (
                                  cld_to_be_picked_count += insideItem.totalIcldQty) : (cld_to_be_picked_count += insideItem.totalIcldQty)
                              }
                              return (
                                <tr className="tbody_align"

                                >

                                  <td> {index + 1}</td>

                                  {/*<td> {insideItem.binAddress}</td>*/}


                                  <td> {insideItem.sku7_code} </td>
                                  {/* <td> {insideItem.lbSkuProductName} </td>*/}
                                  {insideItem.fragile == 1 ? (
                                    <td style={{ padding: 0 }}>  <div style={{
                                      background: '#FFE7A1',
                                      borderTopLeftRadius: 16,
                                      width: '82%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      padding: '5px', marginTop: 0
                                    }}>
                                      <img src={StarIcon} style={{ width: 13, marginRight: 5 }} />
                                      <span style={{ fontSize: 11, fontFamily: 'system-ui' }}>Fragile item. Handle Carefully</span>
                                    </div> <span style={{ marginLeft: 5 }}> {insideItem.lbSkuProductName} </span> </td>
                                  ) : (
                                    <td> {insideItem.lbSkuProductName} </td>
                                  )}


                                  <td> {insideItem.upc} </td>
                                  <td> {insideItem.mrp} </td>
                                  {/* <td>{insideItem.pkd}</td>*/}
                                  {insideItem.freeProduct == true ? (
                                    <td style={{ fontSize: 15, fontWeight: 'bold' }}> {insideItem.lbSkuProductName} </td>
                                  ) : (
                                    <td> </td>
                                  )}
                                  {insideItem.freeProduct == true ? (
                                    <td style={{ fontSize: 15, fontWeight: 'bold' }}>  </td>
                                  ) : (
                                    <td> </td>
                                  )}
                                  {insideItem.freeProduct == true ? (
                                    <td style={{ fontSize: 15, fontWeight: 'bold' }}> {insideItem.totalIcldQty} </td>
                                  ) : (
                                    <td> </td>
                                  )}
                                  {insideItem.freeProduct == false ? (
                                    <td style={{ fontSize: 15, fontWeight: 'bold' }}>  </td>
                                  ) : (
                                    <td> </td>
                                  )}
                                  <td style={{ fontSize: 15, fontWeight: 'bold' }}>  </td>
                                  {(insideItem.freeProduct == false) && (insideItem.totalIcldQty == 0 || insideItem.totalIcldQty == "") ? (

                                    <td style={{ backgroundColor: insideItem.totalIcldQty > 0 ? "#ddd" : "#fff", fontSize: insideItem.totalIcldQty > 0 ? 16 : 15, fontWeight: 'bold' }}> {insideItem.totalIcldQty} </td>
                                  ) : (
                                    <td style={{ backgroundColor: insideItem.totalIcldQty > 0 ? "#ddd" : "#fff", fontSize: insideItem.totalIcldQty > 0 ? 16 : 15, fontWeight: 'bold' }}> {insideItem.totalIcldQty} </td>
                                  )}
                                  <td> {insideItem.pickedCld} </td>
                                </tr>
                              );
                            })
                            }

                          </tbody>

                        </table>

                        {(page_break_check_val == "false") &&

                          <div>
                            <table style={{ width: '90%', margin: 'auto', borderWidth: 0, marginBottom: 6 }}>
                              <tr>
                                <td style={{ borderWidth: 0 }} colspan="6">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      Picker Name:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>

                                <td style={{ borderWidth: 0, textAlign: 'center' }} colspan="5">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      Loose Conf Name:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>
                              </tr>

                              <tr>
                                <td style={{ borderWidth: 0 }} colspan="6">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      Start time:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>

                                <td style={{ borderWidth: 0, textAlign: 'center' }} colspan="5">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      Start Time:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>
                              </tr>

                              <tr>
                                <td style={{ borderWidth: 0 }} colspan="6">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      End Time:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>

                                <td style={{ borderWidth: 0, textAlign: 'center' }} colspan="5">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      End time:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>
                              </tr>

                              <tr>
                                <td style={{ borderWidth: 0 }} colspan="6">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      Sign:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>


                              </tr>
                            </table>

                          </div>
                        }

                        <div className="separater" />
                        {(page_break_check_val == "false") &&
                          <div className="page-break1">


                          </div>



                        }
                      </div>



                    }



                  </div>



                </div>


              ))}

              {(page_break_check_val == "true") &&

                <div>
                  <table style={{ width: '90%', margin: 'auto', borderWidth: 0, marginBottom: 6 }}>
                    <tr>
                      <td style={{ borderWidth: 0 }} colspan="6">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Picker Name:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>

                      <td style={{ borderWidth: 0, textAlign: 'center' }} colspan="5">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Loose Conf Name:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ borderWidth: 0 }} colspan="6">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Start time:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>

                      <td style={{ borderWidth: 0, textAlign: 'center' }} colspan="5">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Start Time:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ borderWidth: 0 }} colspan="6">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            End Time:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>

                      <td style={{ borderWidth: 0, textAlign: 'center' }} colspan="5">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            End time:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ borderWidth: 0 }} colspan="6">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Sign:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>
                      <td style={{ borderWidth: 0 }} colspan="6">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            CLD To be picked Count: {cld_to_be_picked_count}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>


                    </tr>
                  </table>

                </div>
              }

              {(page_break_check_val == "true") &&
                <div className="page-break">


                </div>



              }



            </div>





          )

          )}


        </div>



        <table className="no_border_table" style={{ borderWidth: 0, backgroundColor: '#fff', marginBottom: 0, width: '99%', margin: 'auto', marginTop: 30 }}
        >
          <thead className="table_background"
            style={{ background: "#fff" }}
          >
            <tr style={{ marginTop: 20, background: "#fff" }}>

              <th style={{ textAlign: 'center' }} colspan="12">Loose Picking Sheet</th>

            </tr>
          </thead>
        </table>

        <div>
          {Object.keys(printDetails).map((user) => (


            <div>


              {Object.keys(printDetails[user]).map((zoneName) => (

                <div style={{ width: "99%", margin: 'auto', paddingBottom: 0 }}>
                  <span style={{ display: 'none' }}>{userIndex = userIndex + 1}</span>
                  <span style={{ display: 'none' }}>{itemLen = Object.keys(zoneName).length}</span>
                  <span style={{ display: 'none' }}>{zoneNameArr = []}</span>
                  <div

                  >
                    {pickType == "manual" &&

                      <div id="picksheetAlignment">
                        <table id="picksheet_table" style={{ width: '100%', padding: 15, borderWidth: 0, marginTop: 20 }}
                          responsive

                        >
                          <thead
                            className="thead_align table_background"
                            style={{ background: "#fff" }}
                          >


                            <tr className="header_color" style={{ marginTop: 20, background: "#fff" }}>
                              <th colspan="3" style={{ marginTop: 20 }}>
                                <h5>
                                  {" "}
                                  <span style={{ fontWeight: "bold", color: '#fff' }}>
                                    {" "}
                                    Trip ID:{" "}
                                  </span>{" "}
                                  <span style={{ color: '#fff' }}> {printDetails[user][zoneName][0].ptlId} </span>{" "}
                                </h5>
                              </th>

                              <th colspan="2" style={{ marginTop: 20 }}>
                                <h5>
                                  {" "}
                                  <span style={{ fontWeight: "bold", color: '#fff' }}>
                                    {" "}
                                    Van:{" "}
                                  </span>{" "}
                                  <span style={{ color: '#fff' }}> {printDetails[user][zoneName][0].van} </span>{" "}
                                </h5>
                              </th>
                              <th colspan="2" style={{ marginTop: 20 }}>
                                <h5>
                                  {" "}
                                  <span style={{ fontWeight: "bold", color: '#fff' }}>
                                    {" "}
                                    Zone:{" "}
                                  </span>{" "}
                                  <span style={{ color: '#fff' }}>  {printDetails[user][zoneName][0].zoneName} </span>{" "}
                                </h5>
                              </th>
                              <th colspan="4" style={{ marginTop: 20 }}>
                                <h5>
                                  {" "}
                                  <span style={{ fontWeight: "bold", color: '#fff' }}>
                                    {" "}
                                    Assigned User:{" "}
                                  </span>{" "}
                                  <span style={{ color: '#fff' }}> {user} </span>{" "}
                                </h5>
                              </th>
                              <th colspan="3" style={{ marginTop: 20, textAlign: 'right' }}>
                                <h5>
                                  {" "}
                                  <span style={{ fontWeight: "bold", color: '#fff' }}>
                                    {" "}
                                    Trip Date:{" "}
                                  </span>{" "}
                                  <span style={{ color: '#fff' }}>{printDetails[user][zoneName][0].added_on}</span>{" "}
                                </h5>
                              </th>

                            </tr>



                            <tr className="border-thead border_head border_thead" style={{ marginTop: 20 }}>
                              <th style={{ marginTop: 20 }}>Sr No.</th>

                              {/* <th style={{ marginTop: 20, width: 110 }}>Bin Id </th>*/}

                              <th style={{ marginTop: 20 }}>SkU7 </th>
                              <th style={{ marginTop: 20 }}> Prod Name </th>



                              <th style={{ marginTop: 20 }}> UPC </th>

                              <th style={{ marginTop: 20 }}>MRP </th>
                              {/*<th style={{ marginTop: 20 }}>PKD</th>*/}

                              <th style={{ marginTop: 20 }}>Free Product </th>
                              <th style={{ marginTop: 20 }}>Free Loose </th>

                              <th style={{ marginTop: 20 }}>Free CLD </th>
                              <th style={{ marginTop: 20 }}>Loose to be picked </th>
                              <th style={{ marginTop: 20 }}>Picked loose </th>
                              <th style={{ marginTop: 20 }}>CLD to be picked </th>
                              <th style={{ marginTop: 20 }}>Picked CLD </th>
                            </tr>
                          </thead>
                          <tbody>

                            {printDetails[user][zoneName].filter(valueDetail => valueDetail.totalLooseQty > 0).map((insideItem, index) => {
                              {
                                (insideItem.freeProduct == false) && (insideItem.totalIcldQty == 0 || insideItem.totalIcldQty == "") ? (
                                  cld_to_be_picked_count += insideItem.totalIcldQty) : (cld_to_be_picked_count += insideItem.totalIcldQty)
                              }
                              return (
                                <tr className="tbody_align"

                                >

                                  <td> {index + 1}</td>

                                  {/* <td> {insideItem.binAddress}</td>*/}


                                  <td> {insideItem.sku7_code} </td>
                                  {/*<td> {insideItem.lbSkuProductName} </td>*/}
                                  {insideItem.fragile == 1 ? (
                                    <td style={{ padding: 0 }}>  <div style={{
                                      background: '#FFE7A1',
                                      borderTopLeftRadius: 16,
                                      width: '82%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      padding: '5px', marginTop: 0
                                    }}>
                                      <img src={StarIcon} style={{ width: 13, marginRight: 5 }} />
                                      <span style={{ fontSize: 11, fontFamily: 'system-ui' }}>Fragile item. Handle Carefully</span>
                                    </div> <span style={{ marginLeft: 5 }}> {insideItem.lbSkuProductName} </span> </td>
                                  ) : (
                                    <td> {insideItem.lbSkuProductName} </td>
                                  )}


                                  <td> {insideItem.upc} </td>
                                  <td> {insideItem.mrp} </td>
                                  {/* <td>{insideItem.pkd}</td>*/}
                                  {insideItem.freeProduct == true ? (
                                    <td style={{ fontSize: 15, fontWeight: 'bold' }}> {insideItem.lbSkuProductName} </td>
                                  ) : (
                                    <td> </td>
                                  )}
                                  {insideItem.freeProduct == true ? (
                                    <td style={{ fontSize: 15, fontWeight: 'bold' }}> {insideItem.totalLooseQty} </td>
                                  ) : (
                                    <td> </td>
                                  )}
                                  {insideItem.freeProduct == true ? (
                                    <td style={{ fontSize: 15, fontWeight: 'bold' }}>  </td>
                                  ) : (
                                    <td> </td>
                                  )}
                                  {insideItem.freeProduct == false ? (
                                    <td style={{ fontSize: 15, fontWeight: 'bold' }}> {insideItem.totalLooseQty} </td>
                                  ) : (
                                    <td> </td>
                                  )}
                                  <td style={{ fontSize: 15, fontWeight: 'bold' }}> {insideItem.pickedLoose} </td>
                                  {(insideItem.freeProduct == false) && (insideItem.totalIcldQty == 0 || insideItem.totalIcldQty == "") ? (

                                    <td style={{ backgroundColor: insideItem.totalIcldQty > 0 ? "#ddd" : "#fff", fontSize: insideItem.totalIcldQty > 0 ? 16 : 15, fontWeight: 'bold' }}>  </td>
                                  ) : (
                                    <td style={{ backgroundColor: insideItem.totalIcldQty > 0 ? "#ddd" : "#fff", fontSize: insideItem.totalIcldQty > 0 ? 16 : 15, fontWeight: 'bold' }}>  </td>
                                  )}
                                  <td>  </td>
                                </tr>
                              );
                            })
                            }

                          </tbody>

                        </table>

                        {(page_break_check_val == "false") &&

                          <div>
                            <table style={{ width: '90%', margin: 'auto', borderWidth: 0, marginBottom: 6 }}>
                              <tr>
                                <td style={{ borderWidth: 0 }} colspan="6">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      Picker Name:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>

                                <td style={{ borderWidth: 0, textAlign: 'center' }} colspan="5">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      Loose Conf Name:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>
                              </tr>

                              <tr>
                                <td style={{ borderWidth: 0 }} colspan="6">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      Start time:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>

                                <td style={{ borderWidth: 0, textAlign: 'center' }} colspan="5">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      Start Time:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>
                              </tr>

                              <tr>
                                <td style={{ borderWidth: 0 }} colspan="6">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      End Time:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>

                                <td style={{ borderWidth: 0, textAlign: 'center' }} colspan="5">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      End time:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>
                              </tr>

                              <tr>
                                <td style={{ borderWidth: 0 }} colspan="6">
                                  <h5>
                                    {" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      Sign:{" "}
                                    </span>{" "}
                                    <span> </span>{" "}
                                  </h5>
                                </td>


                              </tr>
                            </table>

                          </div>
                        }

                        <div className="separater" />
                        {(page_break_check_val == "false") &&
                          <div className="page-break1">


                          </div>



                        }
                      </div>



                    }



                  </div>



                </div>


              ))}

              {(page_break_check_val == "true") &&

                <div>
                  <table style={{ width: '90%', margin: 'auto', borderWidth: 0, marginBottom: 6 }}>
                    <tr>
                      <td style={{ borderWidth: 0 }} colspan="6">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Picker Name:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>

                      <td style={{ borderWidth: 0, textAlign: 'center' }} colspan="5">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Loose Conf Name:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ borderWidth: 0 }} colspan="6">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Start time:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>

                      <td style={{ borderWidth: 0, textAlign: 'center' }} colspan="5">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Start Time:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ borderWidth: 0 }} colspan="6">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            End Time:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>

                      <td style={{ borderWidth: 0, textAlign: 'center' }} colspan="5">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            End time:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ borderWidth: 0 }} colspan="6">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            Sign:{" "}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>
                      <td style={{ borderWidth: 0 }} colspan="6">
                        <h5>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            {" "}
                            CLD To be picked Count: {cld_to_be_picked_count}
                          </span>{" "}
                          <span> </span>{" "}
                        </h5>
                      </td>


                    </tr>
                  </table>

                </div>
              }

              {(page_break_check_val == "true") &&
                <div className="page-break">


                </div>



              }



            </div>





          )

          )}


        </div>


      </div>
    );
  }
}

export default PrintPickingNPPHulDetail;